import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const IDENTIFICATIONS_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'identifications'

export const identifications = Object.freeze({
  async fetchList(id) {
    const response = await axiosInstance.get(
      `${IDENTIFICATIONS_URL}/${ENTITY}/${id}/list?size=${1000}&page=${0}`
    )
    return response.data
  },
  async approveIdentification(id, data) {
    const response = await axiosInstance.post(
      `${IDENTIFICATIONS_URL}/${ENTITY}/${id}/approveIdentification`,
      data
    )
    return response.data
  },
  async declineIdentification(id, data) {
    const response = await axiosInstance.post(
      `${IDENTIFICATIONS_URL}/${ENTITY}/${id}/declineIdentification`,
      data
    )
    return response.data
  },
  async resetIdentification(id) {
    const response = await axiosInstance.post(`${IDENTIFICATIONS_URL}/${ENTITY}/${id}/reset`)
    return response.data
  },
  async changeIdentification(id, data) {
    const response = await axiosInstance.post(
      `${IDENTIFICATIONS_URL}/${ENTITY}/${id}/changeIdentification`,
      data
    )
    return response.data
  },
})
